<template>
  <header>
    <div class="page-banner home-banner bg-green-100 dark:bg-gray-800">
      <div class="container h-100">
        <div class="row align-items-center h-100">
          <div class="col-lg-6 py-3 wow fadeInUp">
            <p
              class="text-green-600 hover:text-green-500 text-2xl lg:text-4xl font-medium lg:font-semibold mb-5 lg:leading-normal leading-snug"
            >
              Adrien NICOLAS
              <br />
              Software developer,
              <br />
              AI enthusiast,
              <br />
              ...
            </p>
            <p class="hidden lg:block text-2xl mb-5">
              Discover, learn and explore new things.
            </p>

            <router-link
              to="/about"
              name="fade"
              class="btn btn-outline border text-green-600 hover:border-green-500"
            >
              About
            </router-link>
            <a
              href="Resume.pdf"
              target="_blank"
              class="btn btn-primary btn-split ml-2 bg-green-600 hover:bg-green-500"
            >
              Resume
              <div class="fab bg-green-500 dark:bg-gray-900">
                <span class="mai-play text-white"></span>
              </div>
            </a>
          </div>
          <div class="col-lg-6 wow zoomIn">
            <div class="m-3 lg:m-3 p-1 lg:p-5">
              <img src="../assets/favicon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- Existing "AN&Digit" button -->
      <div class="container text-center mt-3 mb-2">
        <div class="tag-animation">
          <span class="tag">New</span>
          <router-link
            to="/andigit"
            class="btn btn-primary btn-lg mt-2 bg-green-600 hover:bg-green-500"
          >
            AN&Digit
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style>
/* Existing styles (no need to change) */

/* Add this CSS to create the button animation */
.btn {
  transition: transform 0.3s ease;
}

.btn:hover {
  transform: scale(1.1);
}

/* New CSS for the tag animation */
.tag-animation {
  display: inline-block;
  position: relative;
}

.tag {
  position: absolute;
  top: -10px;
  left: -8px;
  padding: 2px 8px;
  background-color: #f87171;
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-radius: 8px;
  animation: colorChange 2s infinite;
}

@keyframes colorChange {
  0% {
    background-color: #f87171;
  }
  50% {
    background-color: #fca5a5;
  }
  100% {
    background-color: #f87171;
  }
}
</style>
